import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsNotificationsAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-notifications-associate',
	path: '/secure/project/SelectProjectScheme!default.jspa',
};
